import "./GridStyles.css";
import React from "react";
import GridData from "./GridData";
import growImg from "../../assets/images/GROW_img.png";
import powerBIimg from "../../assets/images/contoso_powerBI.png";
import uwpImg from "../../assets/images/space_invaders.png";
import azureCognitive from "../../assets/images/Analyze Test Demo.png";
import djangoImg from "../../assets/images/djangoimg.jpg";

function Grid() {
  return (
    <>
      <div className="grid">
        <h1>Welcome to my Portfolio!</h1>
        <p>
          Here you'll find a selection of my programming projects, highlighting
          my skills and experience as a software developer.
        </p>
        <br />
        <h3>More proyects are yet to come!</h3>
        <div className="gridCard">
          <GridData
            image={growImg}
            heading="GROW-POS"
            text="CRM for community sponsored project. Me and my team build this project"
            url="https://github.com/Lmarquez1983/GROW-CRM_"
          />

          <GridData
            image={powerBIimg}
            heading="Dashboard in PowerBI"
            text="Dynamic dashboard retrieving data from Contoso Database"
            url="https://www.dropbox.com/s/4707d0zsk2lys5n/Contoso_Dashboard.pbix?dl=0"
          />

          <GridData
            image={uwpImg}
            heading="Space Invaders Game"
            text="Game in UWP using C#"
            url="https://github.com/Lmarquez1983/UWPGame"
          />
          <GridData
            image={azureCognitive}
            heading="Azure Cognitive Services Demo"
            text="Blazor Web App using Azure Cognitive Services"
            url="https://github.com/Lmarquez1983/Ticket-reader-demo"
          />
          <GridData
            image={djangoImg}
            heading="Inventory Management System"
            text="Products and Staff registering system built using Django"
            url="https://github.com/Lmarquez1983/InventoryMgmt"
          />
        </div>
      </div>
    </>
  );
}

export default Grid;
